import i18next from 'i18next';

const columns = () => [
  {
    accessor: 'head',
  },
  {
    accessor: 'type',
  },
  {
    accessor: 'observations',
  },
];

const parseData = (data, type) => {
  return data.map((item, index) => {
    return {
      ...item,
      head: index === 0 ? i18next.t(type) : ' ',
      type: i18next.t(item.type),
    };
  });
};

export { columns, parseData };
